import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/auth";
import InstallPrompt from "@/components/InstallPrompt";
import Login from "@/pages/Login";
import SetPassword from "@/pages/SetPassword";
import ClientDashboard from "@/pages/client/ClientDashboard";
import AdminHome from "@/pages/admin/AdminHome";
import StructureDetail from "@/pages/admin/StructureDetail";
import PricingStrategyPage from "@/pages/admin/PricingStrategyPage";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminPreview from "@/pages/admin/AdminPreview";
import AdminPartners from "@/pages/admin/AdminPartners";
import PartnerHome from "@/pages/partner/PartnerHome";
import { homeForRole } from "@/api";

function FullScreen({ children }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#12100E] text-[#FAF7F2]">
      {children}
    </div>
  );
}

function Guard({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreen><span className="eyebrow text-[#857C72]">Caricamento…</span></FullScreen>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={homeForRole(user.role)} replace />;
  }
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <FullScreen><span className="eyebrow text-[#857C72]">Caricamento…</span></FullScreen>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={homeForRole(user.role)} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <InstallPrompt />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/imposta-password" element={<SetPassword />} />
          <Route path="/client/dashboard" element={<Guard role="CLIENT"><ClientDashboard /></Guard>} />
          <Route path="/admin" element={<Guard role="ADMIN"><AdminHome /></Guard>} />
          <Route path="/admin/settings" element={<Guard role="ADMIN"><AdminSettings /></Guard>} />
          <Route path="/admin/structures/:id" element={<Guard role="ADMIN"><StructureDetail /></Guard>} />
          <Route path="/admin/structures/:id/strategia" element={<Guard role="ADMIN"><PricingStrategyPage /></Guard>} />
          <Route path="/partner" element={<Guard role="PARTNER"><PartnerHome /></Guard>} />
          <Route path="/admin/partner" element={<Guard role="ADMIN"><AdminPartners /></Guard>} />
          <Route path="/admin/preview/:id" element={<Guard role="ADMIN"><AdminPreview /></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
